(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recently-viewed"]) return;
  try {
    
  class ProductRecentlyViewed extends HTMLElement {
    constructor() {
      super();
      this.displayRecentlyViewedProducts();
    }

    displayRecentlyViewedProducts() {
      // Retrieve the limit from the data attribute and parse it as an integer
      const limit = parseInt(this.dataset.limit, 10);
      let recentlyViewed = JSON.parse(localStorage.getItem('osea.recentlyViewed')) || [];

      // Trim the array to the specified limit
      recentlyViewed = recentlyViewed.slice(0, limit);

      if (recentlyViewed.length > 0) {
        recentlyViewed.forEach((productId) => {
          // Fetch product details via AJAX or Liquid and display
          fetch(`/products/${productId}.js`)
            .then(response => response.json())
            .then(product => {
              // Add product details to a section on the page
              let productHtml = `<li>
                                  <a href="${product.url}">
                                    <img src="${product.featured_image}" alt="${product.title}" class="block mb-2">
                                    <p class="text-sm 2xs:text-base font-bold 2xs:font-medium !leading-[1.1] hover:underline mb-1">${product.title}</p>
                                  </a>
                                  <a href="${product.url}" class="link">
                                    <span>View product</span>
                                  </a>
                                </li>`;
              document.querySelector('.product-recently-viewed ul').innerHTML += productHtml;
            });
        });
      }
    }
  }

  customElements.define('product-recently-viewed', ProductRecentlyViewed);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-product-card"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get("sticky-product-card")) {
    customElements.define(
      "sticky-product-card",
      class StickyProductCard extends HTMLElement {
        connectedCallback() {
          // Only manage the shared --sticky-atc-height var (which the theme uses to lift the
          // Gorgias chat widget above sticky bars) when the PDP's own <product-sticky-atc> is
          // absent, so the two never fight over the same variable on a product page.
          this.managesChatOffset = !document.querySelector("product-sticky-atc");

          const selector = (this.dataset.observerTarget || "").trim();

          // No observer target, or no IntersectionObserver support: always show the card.
          if (!selector || !("IntersectionObserver" in window)) {
            this.show();
            return;
          }

          const target = document.querySelector(selector);
          if (!target) {
            // Fail open: if the target can't be found, show the card so ATC still works.
            console.warn(
              `[sticky-product-card] Observer target "${selector}" not found on page; showing card.`
            );
            this.show();
            return;
          }

          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                // Hide the card while the target (e.g. the hero ATC) is in view;
                // reveal it once the target scrolls out of view.
                if (entry.isIntersecting) {
                  this.hide();
                } else {
                  this.show();
                }
              });
            },
            { threshold: 0 }
          );
          this.observer.observe(target);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.setChatOffset(0);
        }

        show() {
          this.dataset.visible = "true";
          this.inert = false;
          // offsetHeight ignores the transform/opacity used for the animation, so it reports
          // the card's true laid-out height even mid-transition.
          this.setChatOffset(this.offsetHeight);
        }

        hide() {
          this.dataset.visible = "false";
          this.inert = true;
          this.setChatOffset(0);
        }

        // Lift the Gorgias chat button/window above the card via the theme's shared
        // --sticky-atc-height variable (see the Gorgias rules in application.css).
        setChatOffset(px) {
          if (!this.managesChatOffset) return;
          document.documentElement.style.setProperty("--sticky-atc-height", `${px}px`);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
